console.log(`
    \ _   _      _ _         _____ _
    | | | | ___| | | ___   |_   _| |__   ___ _ __ ___
    | |_| |/ _ \\ | |/ _ \\    | | | '_ \\ / _ \\ '__/ _ \\
    |  _  |  __/ | | (_) |   | | | | | |  __/ | |  __/
    |_| |_|\\___|_|_|\\___/    |_| |_| |_|\\___|_|  \\___|
    `);

/* +-----------------------------------------+
|           GLOBALS AREA             		 |
+-----------------------------------------+ */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.DEBUG = false;
window.MNK = !ScrollTrigger.isTouch;
window.TOUCH = !!ScrollTrigger.isTouch;
window.ELEMENTOR = window.location.href.includes("elementor");

/* +-----------------------------------------+
|           IMPORTS AREA             		 |
+-----------------------------------------+ */

// CSS
import "../css/frontend.css";

// Utilities
import getDimensions from "./utilities/getDimensions";
import initMouseFollower from "./utilities/initMouseFollower";
import typeWritter from "./utilities/typeWritter";

// Components
import initWorldMap from "./components/worldMap";

// Elementor
import initParallax from "./elementor/initParallax";

// GSAP
import initGsap from "./gsap/initGsap";
import initGsapTriggers from "./gsap/utilities/initGsapTriggers";
import initGsapTimelines from "./gsap/utilities/initGsapTimelines";
import initGsapLenis from "./gsap/utilities/initGsapLenis";
import gsapScrollTo from "./gsap/utilities/gsapScrollTo";

/* +-----------------------------------------+
|           EVENTS AREA             		 |
+-----------------------------------------+ */

// DOC Ready
document.addEventListener(
    "DOMContentLoaded",
    () => {
        document.body.classList.add("PAGE-IS--LOADING");

        if (!ELEMENTOR) {
            getDimensions(".elementor-location-header", "height");
        }
    },
    false
);

// WINDOW Ready
window.addEventListener(
    "load",
    () => {
        document.body.classList.remove("PAGE-IS--LOADING");
        document.body.classList.add("PAGE-IS--LOADED");

        if (!ELEMENTOR) {
            initGsapLenis();

            initParallax();
            initGsap();
            initGsapTriggers();
            initGsapTimelines();

            if (MNK) initMouseFollower();
            typeWritter();
            initWorldMap();

            // Scroll to anchor if there is one
            const hash = window.location.hash;
            if (hash) gsapScrollTo(hash);

            // Site Menu Toggling
            const siteMenu = document.querySelector("#site-menu");
            const siteMenuToggler = document.querySelector(
                "#site-menu-toggler .menu-toggler"
            );

            siteMenuToggler.addEventListener("click", () => {
                siteMenu.classList.toggle("show");
                siteMenuToggler.classList.toggle("is-active");
            });
        }
    },
    false
);

// WS Form
(function ($) {
    $(document).on("wsf-rendered", function (e, form, form_id, instance_id) {
        getDimensions(".iti__flag-container", "width");
        getDimensions(".wsf-field", "height");
    });
})(jQuery);
